
import * as appM from "@/api/appMessages";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import detail from "./update.vue";
@Component({
  components: {
    lsPagination,
    LsDialog,
    DatePicker,
    detail
  },
})
export default class AppointmentMessageList extends Vue {
  /** S Data **/

  apiAppLists = appM.apiAppLists;

  pager: RequestPaging = new RequestPaging();
  detailForm: any = {};//详情
  searchObj: Object = {
    type: "",
    status: "",
    keyword: "",
    create_time_start: "",
    create_time_end: "", 
  };
  valibleDetail: boolean = false;
  /** E Data **/

  /** S Methods **/

  // 获取预约列表
  getSetMealLists(): void {
    this.pager.request({
      callback: this.apiAppLists,
      params: {
        ...this.searchObj,
      },
    });
  }
 
  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getSetMealLists();
  }

  // 去编辑商城
  toAppDetail(id: number | any): void {
    appM.apiAppDetail({ id: id }).then((res:any) => {
     this.detailForm = res
     this.valibleDetail=true
     
   })
  }
 
  /** E Methods **/

  /** S ods **/
  created() {
    this.getSetMealLists();
  }
}
